import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Footer from '../../app/layout/Footer';
import { useAppContext } from '../../app/provider/useAppContext';

import * as sessionService from './services/session';

import { loginService } from './index';


const AccountPage = () => {
    const [context] = useAppContext();
    const { loggedIn, userInfo } = context;
    const navigate = useNavigate();

    // Check if user is logged in (either via context or ping token)
    const pingToken = sessionService.getAccessToken();
    const isLoggedIn = loggedIn || !!pingToken;

    // If user is already logged in and there's a postLoginRedirect, redirect them there
    // This runs on every render to catch cases where Ping auto-logins via session cookie
    useEffect(() => {
        if (isLoggedIn) {
            const redirectPath = localStorage.getItem('postLoginRedirect');
            if (redirectPath) {
                localStorage.removeItem('postLoginRedirect');
                navigate(redirectPath, { replace: true });
            }
        }
    }, [isLoggedIn, navigate]);
    if (!isLoggedIn) {
        return (
            <div className="flex flex-col min-h-[calc(100vh-36px)] font-sans" >
                <div className="flex justify-center items-center flex-grow flex-col" >
                    <h2 className="text-2xl font-bold mb-4" >
                        {
                            localStorage.getItem('postLoginRedirect')?.includes('checkout')
                                ? 'Please Log In to Checkout'
                                : 'Please Log In'
                        }
                    </h2>
                    < p className="text-gray-600 mb-6" > Access your account by logging in.</p>
                    < button
                        onClick={async () => {
                            // Determine redirect path
                            let redirectPath = localStorage.getItem('postLoginRedirect');
                            if (!redirectPath) {
                                redirectPath = window.location.pathname + window.location.search;
                                localStorage.setItem('postLoginRedirect', redirectPath);
                            }
                            const url = await loginService.getLoginUrl();
                            window.location.href = url;
                        }}
                        className="bg-black text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors"
                    >
                        Log In
                    </button>
                </div>
                < Footer />
            </div>
        );
    }

    return (
        <div className="flex flex-col min-h-screen" >
            <div className="max-w-[1240px] mx-auto p-6 font-sans flex-grow w-full" >
                <h1 className="text-3xl font-bold mb-8 border-b pb-4" > My Account </h1>

                < div className="bg-white shadow rounded-lg p-6 max-w-2xl" >
                    <h2 className="text-xl font-semibold mb-4 text-gray-800" > Profile Information </h2>

                    < div className="space-y-3 text-gray-700" >
                        <div className="flex border-b border-gray-100 py-2" >
                            <span className="font-medium w-32" > Name: </span>
                            < span > {userInfo?.name || `${userInfo?.given_name || ''} ${userInfo?.family_name || ''}`}</span>
                        </div>
                        < div className="flex border-b border-gray-100 py-2" >
                            <span className="font-medium w-32" > Email: </span>
                            < span > {userInfo?.email || 'N/A'}</span>
                        </div>
                        {/* Add more fields as available/needed */}
                    </div>
                </div>
            </div>
            < Footer />
        </div>
    );
};

export default AccountPage;
